import { useAtom } from 'jotai'
import { adminViewEnabledAtom } from 'Automations/watchtower/inbox/manualTasks/manualTasksInbox/atoms'
import {
  Button,
  IndigoIndigo50,
  Popover,
  SwitchLineField,
  IconSettingsSliderHorizontal,
  Box,
  Flex
} from '@sequencehq/core-components'
import { usePermissions } from 'lib/rbac'

interface AdminSettingsButtonProps {
  onToggleOff?: () => void
}

export const AdminSettingsButton = ({
  onToggleOff
}: AdminSettingsButtonProps) => {
  const [adminViewEnabled, setAdminViewEnabled] = useAtom(adminViewEnabledAtom)
  const { isAdmin } = usePermissions()

  if (!isAdmin) {
    return null
  }

  return (
    <Popover
      content={
        <SwitchLineField
          data-testid="watchtower.adminSettings.adminMode"
          text="Admin mode"
          value={adminViewEnabled}
          onChange={() => {
            if (adminViewEnabled) {
              onToggleOff?.()
            }
            setAdminViewEnabled(prev => !prev)
          }}
        />
      }
      trigger="click"
      position="bottom-end"
      gutter={10}
      showArrow={false}
    >
      <Button
        variant="secondary"
        data-testid="watchtower.adminSettings"
        icon={
          <Box position="relative">
            <IconSettingsSliderHorizontal color="inherit" />
            <Box
              position="absolute"
              bottom="-1px"
              right="-1px"
              width="6px"
              height="6px"
              bg={IndigoIndigo50}
              borderRadius="50%"
              opacity={adminViewEnabled ? 1 : 0}
              transition="opacity ease-in-out 0.2s"
            />
          </Box>
        }
        aria-label="settings"
      />
    </Popover>
  )
}
